module.exports = __webpack_public_path__ + "img/hall.778cd2de.svg";